'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoFunnel = function IoFunnel(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17.5 2.5c9.7 0 17.5 2.8 17.5 6.3 0 0.6-0.2 1.1-0.7 1.7-2.7 3.3-11.8 14-11.8 17v6.8c0 1.8-2.3 3.2-5 3.2s-5-1.4-5-3.2v-6.8c0-3-9.1-13.8-11.6-16.9-0.6-0.6-0.9-1.2-0.9-1.8 0-3.5 7.8-6.3 17.5-6.3z m0 10c7.2 0 13.8-1.7 13.8-3.7s-6.5-3.8-13.8-3.8-13.7 1.7-13.7 3.8 6.5 3.7 13.7 3.7z' })
        )
    );
};

exports.default = IoFunnel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/funnel.js
// module id = 2034
// module chunks = 0